import { BROWSER } from 'esm-env';
import { readable, writable } from 'svelte/store';

export const ANY_DAY = '';
export const ANY_TAG = 0;
export const ANY_STORE: number[] = [];
export const NO_WISHLIST: number[] = [];
export const ANY_DESCRIPTION: number[] = [];

export const filter_by_category = writable(ANY_TAG);
export const filter_by_day = writable(ANY_DAY);
export const filter_by_store = writable(ANY_STORE);
export const filter_by_offer_content = writable(ANY_DESCRIPTION);
export const filter_by_wishlist = writable(false);

const LIKES_KEY = 'campaign_user_likes';
export const user_likes = createUserLikes();

function createUserLikes() {
  // Provide dummy store for SSR
  if (!BROWSER) {
    const { subscribe } = readable<number[]>([]);
    return {
      subscribe,
      toggle: (id: number) => false,
      isLiked: (id: number) => false,
    };
  }

  // Get previously stored likes
  let likes = (localStorage.getItem(LIKES_KEY) || '').split(',').map(Number);

	const { subscribe, update } = writable<number[]>(likes);

  function updateWithStore (fn: (xs: number[]) => number[]) {
    update(xs => {
      likes = fn(xs);
      localStorage.setItem(LIKES_KEY, likes.join(','));
      return likes;
    })
  }

  function toggle(id: number) {
    let like = false;
    updateWithStore(
      xs => {
        const index = xs.indexOf(id);
        if (index == -1) {
          like = true;
          return xs.concat(id);
        }
        xs.splice(index, 1);
        return xs;
      }
    );
    return like;
  }

	return {
		subscribe,
		toggle,
    isLiked: (id: number) => likes.includes(id),
	};
}
